export default __webpack_public_path__ + "static/media/video.079f09e3.mp4";